import { TitleColor } from '..';
import Text from '../Text';

const Education2022 = () => (
  <>
    <TitleColor text="Kurser 2022" smallTitle />
    <Text>
      <b>Clive Wynne</b>
      <br />
      Weekendseminar "Dog is Love":
      <br />
      <i>
        "Using Behavioral Science to Help Dog in Difficulties and Science, Sense and Nonsense in Dog
        Behavior"
      </i>
    </Text>
  </>
);

export default Education2022;
